import type { Note, Reason } from "@kiwicom/frontend-common/consts/pendingRequests"

import type { DateValue } from "../../../../../../../components/DateField/DateField"

export const STATUS = {
  PENDING: "pending",
  DONE: "done",
} as const

export const FIELDS = {
  FIRST_NAME: "firstname",
  MIDDLE_NAME: "middlename",
  LAST_NAME: "lastname",
  BIRTHDAY: "birthday",
  PASSPORT_NUMBER: "idNumber",
  PASSPORT_EXPIRY: "idExpiration",
} as const

export const FORM_FIELDS = [
  "passengers[].reason",
  "passengers[].id",
  "passengers[].pid",
  "passengers[].note",
  "passengers[].shouldShowMiddleName",
  `passengers[].${FIELDS.FIRST_NAME}`,
  `passengers[].${FIELDS.MIDDLE_NAME}`,
  `passengers[].${FIELDS.LAST_NAME}`,
  `passengers[].${FIELDS.BIRTHDAY}`,
  `passengers[].${FIELDS.PASSPORT_NUMBER}`,
  `passengers[].${FIELDS.PASSPORT_EXPIRY}`,
] as const

// types

export type FieldName = typeof FIELDS[keyof typeof FIELDS]

export type ExpirationDateValue = DateValue

export type BirthDateValue = {
  day: string
  month: string
  year: string
}

export type FormField = {
  reason: Reason
  id: number
  pid: number
  note: Note
  shouldShowMiddleName: boolean
  firstname: string
  middlename: string
  lastname: string
  birthday: BirthDateValue
  idNumber: string
  idExpiration: ExpirationDateValue
}

export type FormFields = FormField[]

export type DateRangeError = {
  t: string
  values: {
    what: string
    lower: number
    upper: number
  }
}

export type FormFieldError = {
  reason: null
  id: null
  pid: null
  note: null
  shouldShowMiddleName: null
  firstname: string | null | undefined
  middlename: string | null | undefined
  lastname: string | null | undefined
  birthday: string | null | undefined | DateRangeError | null | undefined
  idNumber: string | null | undefined
  idExpiration: string | null | undefined | DateRangeError | null | undefined
}

export type PassengerPayload =
  | {
      pid: number
      firstname: string
      middlename?: string
      lastname: string
    }
  | {
      pid: number
      birthday: string
    }
  | {
      pid: number
      cardno: string
      expiration: string | null | undefined
    }
